// 获取节点的文本值（处理对象和字符串情况）
export const getNodeText = (nodeData: any): string => {
  if (!nodeData) return '';

  // 如果 text 是字符串，直接返回
  if (typeof nodeData.text === 'string') {
    return nodeData.text;
  }

  // 如果 text 是对象，尝试获取 value 属性
  if (
    nodeData.text &&
    typeof nodeData.text === 'object' &&
    nodeData.text.value
  ) {
    return nodeData.text.value;
  }

  // 尝试从 properties.name 获取
  if (
    nodeData.properties?.name &&
    typeof nodeData.properties.name === 'string'
  ) {
    return nodeData.properties.name;
  }

  // 最后返回 id 或空字符串
  return nodeData.id || '';
};

// 检查节点是否为状态节点
export const isStateNode = (nodeData: any): boolean => {
  return nodeData?.type === 'state' || nodeData?.properties?.isState === true;
};

// 检查节点是否为值节点
export const isValueNode = (nodeData: any): boolean => {
  return nodeData?.type === 'value' || nodeData?.properties?.isValue === true;
};

// 检查节点是否为实体节点（可以添加状态的节点）
export const isEntityNode = (nodeData: any): boolean => {
  return (
    nodeData?.type === 'rect' ||
    (nodeData?.type === 'dynamic-group' && nodeData?.properties?.isEntityGroup)
  );
};

// 检查节点是否为分组节点
export const isGroupNode = (nodeData: any): boolean => {
  return (
    nodeData?.type === 'dynamic-group' || nodeData?.properties?.isGroup === true
  );
};

// 获取节点的状态列表
export const getNodeStates = (nodeData: any): string[] => {
  return nodeData?.properties?.children || nodeData?.properties?.states || [];
};

// 获取节点的值列表
export const getNodeValues = (nodeData: any): string[] => {
  return nodeData?.properties?.children || nodeData?.properties?.values || [];
};

// 检查节点是否有父分组
export const hasParentGroup = (nodeData: any): boolean => {
  return (
    !!nodeData?.properties?.parentGroupId || !!nodeData?.properties?.parentId
  );
};

// 获取节点的父分组ID
export const getParentGroupId = (nodeData: any): string | null => {
  return (
    nodeData?.properties?.parentGroupId ||
    nodeData?.properties?.parentId ||
    null
  );
};
